export default {
  'webhookMappingGenerationMapping.title': 'Webhook Parameter Mappings',

  'webhookMappingGenerationMapping.form.valueDestination': 'Value Destination',
  'webhookMappingGenerationMapping.form.destinationForm': 'Destination Form',
  'webhookMappingGenerationMapping.form.destinationField': 'Destination Field',
  'webhookMappingGenerationMapping.form.formFieldValueDestination': 'Field Value Destination',
  'webhookMappingGenerationMapping.form.destinationVariable': 'Destination Variable',
  'webhookMappingGenerationMapping.form.sourceParameterPosition': 'Send Location',
  'webhookMappingGenerationMapping.form.sourceParameterCodification': 'Parameter Encoding',

  'webhookMappingGenerationMapping.form.sourceTableParameterName': 'List Parameter Name',
  'webhookMappingGenerationMapping.form.sourceParameterName': 'Parameter Name',
  'webhookMappingGenerationMapping.form.destinationAttachmentFileName': 'Attachment Name',
  'webhookMappingGenerationMapping.form.destinationAttachmentContentType':
    'Attachment Content Type',

  'webhookMappingGenerationMapping.form.select.FormField': 'Form / Field',
  'webhookMappingGenerationMapping.form.select.Variable': 'Variable',
  'webhookMappingGenerationMapping.form.select.InstanceName': 'Request Name',
  'webhookMappingGenerationMapping.form.select.OperationObservations': 'Operation Observations',
  'webhookMappingGenerationMapping.form.select.OperationUserEmail': 'Operation User Email',
  'webhookMappingGenerationMapping.form.select.OperationIsApprovalOrReject':
    'Approval / Rejection Indicator',

  'webhookMappingGenerationMapping.form.select.FieldValue': 'Display Value',
  'webhookMappingGenerationMapping.form.select.FieldSearchValue': 'Search Value',

  'webhookMappingGenerationMapping.form.select.None': 'No Encoding',
  'webhookMappingGenerationMapping.form.select.ByteArray': 'Byte Array',
  'webhookMappingGenerationMapping.form.select.Base64String': 'Base64 String',
  'webhookMappingGenerationMapping.form.select.ZipByteArray': 'Zip File - Byte Array',
  'webhookMappingGenerationMapping.form.select.ZipBase64String': 'Zip File - Base64 String',
  'webhookMappingGenerationMapping.form.select.HttpBodyBinaryData':
    'Binary Encoded in Request Body',

  'webhookMappingGenerationMapping.form.select.Header': 'Header',
  'webhookMappingGenerationMapping.form.select.Url': 'Url',
  'webhookMappingGenerationMapping.form.select.FormData': 'Form Data',
  'webhookMappingGenerationMapping.form.select.BodyJson': 'Body (JSON)',
  'webhookMappingGenerationMapping.form.select.XWwwFormUrlEncoded': 'Form URL Encoded',
  'webhookMappingGenerationMapping.form.select.Authorization': 'Authorization',
};
